module.exports = __webpack_public_path__ + "media/images/front/top/slide_arrow-608af127bfb1ea3c1be8fc81dbaae75d.png";